var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90352 15.3078L2.93836 16.0938C1.68721 16.5943 1.68721 17.4057 2.93836 17.9062L9.73459 20.6247C10.9857 21.1251 13.0143 21.1251 14.2654 20.6247L21.0616 17.9062C22.3128 17.4057 22.3128 16.5943 21.0616 16.0938L19.0965 15.3078L14.8225 17.0174C13.9683 17.359 12.9462 17.5 12 17.5C11.0538 17.5 10.0317 17.359 9.1775 17.0174L4.90352 15.3078Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93836 7.90616C1.68721 7.4057 1.68721 6.5943 2.93836 6.09384L9.73459 3.37535C10.9857 2.87488 13.0143 2.87488 14.2654 3.37535L21.0616 6.09384C22.3128 6.5943 22.3128 7.4057 21.0616 7.90616L14.2654 10.6247C13.0143 11.1251 10.9857 11.1251 9.73459 10.6247L2.93836 7.90616Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90352 10.3078L2.93836 11.0938C1.68721 11.5943 1.68721 12.4057 2.93836 12.9062L9.73459 15.6247C10.9857 16.1251 13.0143 16.1251 14.2654 15.6247L21.0616 12.9062C22.3128 12.4057 22.3128 11.5943 21.0616 11.0938L19.0965 10.3078L14.8225 12.0174C13.9683 12.359 12.9462 12.5 12 12.5C11.0538 12.5 10.0317 12.359 9.1775 12.0174L4.90352 10.3078Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.d588cc0e73134fb7a66f4617f69fcf0f.svg";
export { ForwardRef as ReactComponent };